import { ChannelType } from '@b3networks/api/chat';
import { TxnChannel } from '@b3networks/api/inbox';
import { RequestDetailLeaves } from '@b3networks/api/leave';
import { MatchType } from '@b3networks/shared/common';
import { DeltaStatic } from 'quill';

export class OutputContentQuill {
  mentions: string[];
  msg: string;
  fileId?: string;

  constructor(obj?: Partial<OutputContentQuill>) {
    Object.assign(this, obj);
  }
}

export interface QuillEditorChannel {
  channelId: string;
  channelType: ChannelType;
  txnUuid?: string; // for omni
}

export interface QuillEditorInput {
  context: DeltaStatic | string;
  placeholder: string;
  enableEmoji: boolean;
  enableMention: boolean;
  enableUpload: boolean;
  showCannedRespInboxBy?: TxnChannel;
  showSendButton?: boolean;
  tagHere: boolean;
  noTagEveryone: boolean;
  mentionAssigneeInbox?: string;
  uploadFilesInline: boolean;
}

export class InfoMention {
  id: string;
  value: string;
  identityUuid: string;
  photoUrl: string;
  isOnline: boolean;
  isNotShowStatus: boolean;
  mentionChar: MentionType;
  requestLeaveNow: RequestDetailLeaves;
  nameOrg: string;
  isCurrentOrg: boolean;
  nameCannedResponses: string;
  isNotMember: boolean;

  constructor(obj?: Partial<InfoMention>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  get hasPhoto() {
    return !!this.photoUrl && this.photoUrl.indexOf('http') > -1;
  }

  get photoUrlOrDefault() {
    return this.hasPhoto ? this.photoUrl : 'https://ui.b3networks.com/external/logo/default_org_icon.png';
  }
}

export interface MentionData {
  denotationChar: string;
  id: string;
  index: string;
  value: string;
}

export enum MentionType {
  USER = '@',
  CONVO = '#',
  EMOJI = ':',
  CANNED_RESPONSES = '/'
}

export class QuillItem {
  public constructor(
    public type: MatchType,
    public key: string,
    public text: string,
    public index: number
  ) {}
}

export const EVERYONE = 'everyone';
export const HERE = 'here';
export const TEXT_CHANGE_DEBOUNCE_TIME = 3 * 100;
export const everyoneMention = new InfoMention({
  id: EVERYONE,
  value: EVERYONE,
  identityUuid: EVERYONE,
  photoUrl: '',
  isOnline: false,
  isNotShowStatus: true,
  mentionChar: MentionType.USER
});

export const hereMention = new InfoMention({
  id: HERE,
  value: HERE,
  identityUuid: HERE,
  photoUrl: '',
  isOnline: false,
  isNotShowStatus: true,
  mentionChar: MentionType.USER
});
